import React from 'react'
import StructuredData from './StructuredData'
import { getRootsTechOrganizationData } from './OrganizationStructuredData'
import { get360Events, getRootsTechEvents } from './EventStructuredData'

export const getEventSeriesData = (data, locale, subEvent) => {
  const organizer = getRootsTechOrganizationData()
  return {
    '@type': 'EventSeries',
    name: data.name,
    description: data.description,
    url: data.url || undefined,
    organizer,
    subEvent,
    inLanguage: locale,
  }
}

export const getRootsTechEventSeriesData = () => {
  const subEvent = getRootsTechEvents()
  return getEventSeriesData({ name: 'RootsTech Conference' }, subEvent)
}

export const getEventsPageEventSeriesData = (data) => {
  const subEvent = get360Events(data.content[0]?.items || [], getRootsTechOrganizationData())
  return getEventSeriesData(data, subEvent)
}

export const getEventPageEventSeriesData = (data) => {
  const subEvent = get360Events(data.content[0]?.items || [], getRootsTechOrganizationData())
  return getEventSeriesData(data, subEvent)
}

export default function EventSeriesStructuredData({ data }) {
  if (!data || !data.content || data.content.length === 0) return null
  // Generate subEvent using get360Events
  const subEvent = get360Events(data.content[0]?.items || [])
  const locale = 'en' // or use i18n.language if available
  const structuredData = getEventSeriesData(data, locale, subEvent)
  return <StructuredData data={structuredData} dataTestId="event-series-structured-data" />
}
